'use client';

import { FC, useMemo, useState, useEffect } from 'react';
import { ScheduledMessageDialogProps } from './ScheduledMessageDialog.types';
import { Dialog, Flex, Input, ButtonGroup, Button } from '@/_components';
import { getNDaysAfter, getIsPastDateTime } from '@/_utils/dates';

const TODAYS_DATE: string = getNDaysAfter(0);
const TOMORROWS_DATE: string = getNDaysAfter(1);
const MIN_TIME: string = '09:00';

export const ScheduledMessageDialog: FC<ScheduledMessageDialogProps> = ({
  isOpen,
  isLoading,
  onClose,
  onConfirm,
}) => {
  const [scheduleTime, setScheduleTime] = useState<string>(MIN_TIME);
  const [scheduleDate, setScheduleDate] = useState<string>(TOMORROWS_DATE);

  useEffect(() => {
    setScheduleTime(MIN_TIME);
    setScheduleDate(TOMORROWS_DATE);
  }, [isOpen]);

  const onConfirmSend = () => {
    onConfirm(scheduleDate, scheduleTime);
  };

  const onScheduleDateChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    setScheduleDate(event.target.value);
  const onScheduleTimeChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    setScheduleTime(event.target.value);

  const isBeforeNow: boolean = useMemo(
    () => getIsPastDateTime(scheduleDate, scheduleTime),
    [scheduleDate, scheduleTime],
  );

  return (
    <Dialog isOpen={isOpen} onClose={onClose} title="Schedule Message">
      <Dialog.Content>
        <Flex isColumn={true} gap={8}>
          <Input
            label="Date"
            min={TODAYS_DATE}
            type="date"
            isDisabled={isLoading}
            value={scheduleDate}
            onChange={onScheduleDateChange}
          />
          <Input
            label="Time"
            type="time"
            isDisabled={isLoading}
            value={scheduleTime}
            onChange={onScheduleTimeChange}
          />
          <ButtonGroup align="right">
            <Button
              value="Schedule Message"
              intent="primary"
              isLoading={isLoading}
              isDisabled={
                !scheduleDate || !scheduleTime || isLoading || isBeforeNow
              }
              onClick={onConfirmSend}
            />
          </ButtonGroup>
        </Flex>
      </Dialog.Content>
    </Dialog>
  );
};
